<div class="text-residential-content" id="formResult"
     [innerHTML]="(headerHtml$ | async)">
</div>
